import { Api } from './lib/Api';

export * from './lib/data-contracts';
export const IntegrationApi = new Api();
